<template>
  <div class="world-countries">
    <h4 class="world-countries__title">
      {{ countries.title }}
    </h4>
    <div class="world-countries__flags">
      <a
        v-for="(country,key) in getWorldCountries"
        :key=key
        class="flags_item"
        :href="country.link"
        target="_blank"
      >
        <img
          :data-src="country.flag_desktop"
          :alt="country.name"
          class="lazyload w-[80px] h-[56] lg:w-[96px] lg:h-[64px]"
          width="96"
          height="64"
        >
        <BaseButton flat size="sm">
          {{ country.name }}
        </BaseButton>
      </a>
    </div>
    <p class="world-countries__desc">
      {{ countries.description }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import staticData from './static-data'

export default {
  name: 'WorldCountries',
  data () {
    return {
      ...staticData
    }
  },
  computed: {
    ...mapGetters('local', ['getWorldCountries'])
  }
}
</script>

<style scoped lang="scss">
.world-countries {
  @apply container;
  &__title {
    @apply text-center text__body-1-xs--bold lg:text__headline-4-md--bold text-title mb-2 lg:mb-4;
  }
  &__flags {
    @apply flex justify-between mb-6 lg:mb-9 lg:flex-row flex-col space-y-2 lg:space-y-0;
    .flags_item {
      @apply flex flex-col justify-center items-center;
    }
  }
  &__desc {
    @apply text__body-2-xs--semibold lg:text__body-1-md--semibold text-body-1 text-center;
  }
}
</style>
